import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../../../components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const authHeaders = () => ({ Authorization: `Bearer ${sessionStorage.getItem("access_token")}` });

/** Telegram-like preview of a product card; confirms before publishing to the channel. */
export const TelegramPreviewModal = ({ article, onClose }) => {
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [state, setState] = useState("idle");

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/admin/telegram/channel-post/${article.id}/preview`, { headers: authHeaders() })
      .then((r) => setPreview(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Anteprima non disponibile"));
  }, [article.id]);

  const publish = async () => {
    setState("loading");
    try {
      await axios.post(`${BACKEND_URL}/api/admin/telegram/channel-post/${article.id}`, {}, { headers: authHeaders() });
      setState("done");
      setTimeout(onClose, 1200);
    } catch (e) {
      setError(e.response?.data?.detail || "Pubblicazione fallita");
      setState("idle");
    }
  };

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="telegram-preview-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-[#229ED9] text-white px-4 py-2.5 text-sm font-bold flex justify-between items-center">
          <span>📣 Anteprima post — {preview?.channel || "canale Telegram"}</span>
          <button onClick={onClose} className="text-white/80 hover:text-white text-lg leading-none" data-testid="telegram-preview-close">×</button>
        </div>
        <div className="bg-[#8bb8d6] p-4">
          <div className="bg-white rounded-xl shadow max-w-[320px] mx-auto overflow-hidden" data-testid="telegram-preview-bubble">
            {preview?.photo_url && (
              <img src={preview.photo_url} alt="" className="w-full max-h-64 object-cover" data-testid="telegram-preview-photo"
                onError={(e) => { e.currentTarget.style.display = "none"; }} />
            )}
            <div className="px-3 py-2 text-[13px] leading-snug text-gray-900 whitespace-pre-line [&_a]:text-[#229ED9] [&_a]:underline" data-testid="telegram-preview-caption"
              dangerouslySetInnerHTML={{ __html: preview?.caption_html || (error ? "" : "Caricamento…") }} />
            <div className="px-3 pb-1.5 text-right text-[10px] text-gray-400">{new Date().toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>
          </div>
        </div>
        {error && <p className="text-xs text-red-600 px-4 pt-3" data-testid="telegram-preview-error">{error}</p>}
        <div className="flex justify-end gap-2 p-4">
          <Button variant="outline" onClick={onClose} data-testid="telegram-preview-cancel">Annulla</Button>
          <Button onClick={publish} disabled={!preview || state !== "idle"} className="bg-[#229ED9] hover:bg-[#1c86b8] text-white" data-testid="telegram-preview-publish">
            {state === "loading" ? "Pubblico…" : state === "done" ? "✅ Pubblicato" : "📢 Pubblica ora"}
          </Button>
        </div>
      </div>
    </div>
  );
};
